export enum PlayerEvent {
    START,
    STOP,
    PAUSE
}
